import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Box from '@mui/material/Box';
import './Project.css';
import process from '../../Assets/Projects/process.png';
import persona from '../../Assets/Projects/persona.png';
import visualidentity from '../../Assets/Projects/visualidentity.svg';
import psearch from '../../Assets/Projects/psearch.svg';
import custommenu from '../../Assets/Projects/custommenu.svg';
import lowfidelity from '../../Assets/Projects/lowfidelity.svg';
import crazy8 from '../../Assets/Projects/crazy8.png';
import journeymap from '../../Assets/Projects/journeymap.png';
import ordering from '../../Assets/Projects/ordering.svg';
import tracking from '../../Assets/Projects/track.svg';
import staff from '../../Assets/Projects/staff.svg';
import ecanteen from '../../Assets/Projects/ecanteen.png';
import period from '../../Assets/period.svg';
import {Link} from 'react-router-dom';
import Navbar from "../Navbar";
import Footer from "../Footer";

function ECanteen() {

  return (
    <section>
      <Navbar />
      <Box className="filebox">

            <Row>
            <aside>
              <Col sm={1}>
                <Container style={{ height: '100%' }}>
             
            <div direction="right" className="side-banner">
            <div className="marquee">
              <div className="marquee-content" style={{animationDuration: '120s' }}>
                DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen         DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen         DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen         DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen         DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen         DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen         DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen         DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen         DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          DJSCE E-Canteen          
                </div>
                </div>
                </div>
                </Container>
              </Col>
              <Col sm={10} className="canteen-ui" style={{ paddingLeft: '130px', paddingRight: '70px' }}>
              <Container fluid className="project-section">
          <Container  className="canteen-content">
                <Row className="first-img" style={{ justifyContent: "center", paddingTop: '40px', paddingBottom: "40px" }}>

                <img
                      src={ecanteen}
                      alt="ecanteen"
                      className="img-fluid"
                      style={{marginBottom: '30px', padding: '0px', border: '1px solid white'}}
                    />
                  </Row>
                  <Row style={{paddingBottom: "40px"}}>
                  <div style={{display:'flex'}}>
                  <h1>DJSCE E-Canteen</h1>
                  <img
                    src={period}
                    alt="period"
                    className="img-fluid"
                    style={{marginLeft: '2px', paddingTop: '1%', verticalAlign: 'bottom' }}
                  />
                  </div>
                  <p className="content">A food ordering app designed for D.J. Sanghvi College of Engineering is a convenient solution that enables both students and teachers to place their food orders in advance and collect them with ease. Customers can avoid long lines and save time with this system. It also allows the canteen update menus in real time, keeping consumers informed of the latest food offerings.</p>
                </Row>
                <Row style={{paddingBottom: "56px", fontFamily: 'Changa', fontSize: '1.2em'}} >
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">MY ROLE</p>
                    <p className="box-p">Product Designer, Design Thinking</p>
                    </div>
                    </Col>
                    
                    
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">TIMELINE</p>
                    <p className="box-p">7 days</p>
                    </div>
                    </Col>
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">TOOLS USED</p>
                    <p className="box-p">Figma, Mural</p>
                    </div>
                    </Col>
                </Row>
                <Row style={{paddingBottom: "40px"}}>
                    <Col>
                    <hr></hr>
                    <Row>
                    <div style={{display:'flex'}}>
                      <h2> THE BRIEF</h2> 
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    </Row>
                    <h5>PROMPT</h5>
                    <p className="content">For our Design Thinking project at DJSCE, my team of five had to find and solve any real-life issue/challenge/opportunity in our college (by DXandBeyond). This team-based design thinking exercise gave us hands-on experience.</p>
                    </Col>
                </Row>
                <Row style={{paddingBottom: "64px"}}>
                <img
                      src={process}
                      alt="process"
                      className="img-fluid"
                      style={{ maxHeight: "300px" }}
                    />
                    </Row>
                    <Row style={{paddingBottom: "56px"}}>
                        <Col>
                 <hr></hr>
                    <div style={{display: 'flex'}}>
                    <h2> INITIAL THINKING</h2>
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    <h5>PROBLEM DISCOVERY</h5>
                    <p className="content">Discovered that many students would complain about the canteen not having the items listed on the menu. When the students stood to order food, it would be like a fish market. Due to the commotion, students sometimes missed picking up their orders, and the food eventually became cold. It was a problem not only for the students but also for the canteen as they saw a decrease in their customer base.</p>
                    <h5>TARGET USERS</h5>
                    
                    <p className="content"><ul>
                        <li>Students and Teachers at DJSCE</li>
                        <li>Canteen Staff</li>
                    </ul>
                    </p>
                    </Col>
                </Row>
                <Row style={{paddingBottom: '56px'}}>
                    <Col>
                <hr></hr>
                <div style={{display: 'flex'}}>
                    <h2>EMPATHY RESEARCH</h2>
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                </div>
                    <h4>RESEARCH 1: WALK-A-MILE IMMERSION</h4>
                    <p className="content">To empathize with target users, here students, we immersed ourselves to get first hand knowledge about student’s journey from ordering to receiving their order.</p>
                    <h5 style={{paddingTop:"16px"}}>STUDENT'S PERSPECTIVE:</h5>
                    <p className="content">
                    <ul>
                        <li>No disciplined line to order, hence need to wait for a long time for your turn.</li>
                        <li>Spends lot of time in deciding what to order.</li>
                        <li>Preparation of orders takes a long time, the recess may even end by then.</li>
                        <li>Need to stand in front of the counter to not miss their order.</li>
                    </ul>
                    </p>
                    <h5 style={{paddingTop:"16px"}}>CANTEEN STAFF'S PERSPECTIVE:</h5>
                    <p className="content">
                    <ul>
                        <li>Change not being present, cause long queues for ordering.</li>
                        <li>Single place of cooking causes delay.</li>
                        <li>Shouting to notify when the order is ready.</li>
                        <li>People who order forget don’t pick up their food at the right time.</li>
                    </ul>
                    </p>

                    <h4 style={{paddingTop: "32px"}}>RESEARCH 2: INTERVIEWS</h4>
                    <p className="content">We interviewed 8 students and 2 canteen staffs to help us get a better understanding of their problem. Based on the interviews we created 2 personas and a journey map.</p>
                    <h6 style={{paddingTop:"16px"}}>PERSONA OF A STUDENT AND A STAFF MEMBER:</h6>
                    <img
                      src={persona}
                      alt="persona"
                      className="img-fluid"
                    />

                    <h6 style={{paddingTop:"32px"}}>JOURNEY MAP OF A STUDENT:</h6>
                    
                    <img
                      src={journeymap}
                      alt="Journey Map"
                      className="img-fluid"
                      style={{paddingBottom: '56px'}}
                    />

                    <h5>RESEARCH & FINDINGS/ PAIN POINTS:</h5>
                    <p className="content">
                    <ul>
                        <li>It takes time to order. Since what you crave may not be available at the current moment.</li>
                        <li>It’s challenging to remember specific orders during rush hours. People sometimes have similar order with slightly different specifications.</li>
                        <li>It takes a lot of time to wait for your order. If you end up sitting at your table, you might end up missing your order because of the commotion around you.</li>
                    </ul>
                    </p>
                    </Col>
                </Row>
                <Row style={{paddingBottom: "40px"}}>
                    <Col>
                <hr></hr>
                <div style={{display: 'flex'}}>
                    <h2>PROBLEM DEFINITION
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '3%', verticalAlign: 'bottom' }}
                    /></h2>
                    </div>
                    <h5>HOW MIGHT WE? QUESTIONS:</h5>
                    <p className="content">
                    <ul>
                        <li>How might we improve the canteen ordering system more user-friendly for students and teachers so that the food they order is available, hot, and tasty?</li>
                        <li>How might we assist the canteen staff so that they can show the availability of the food items on the menu?</li>
                    </ul>
                    </p>
                    </Col>
                </Row>
                <Row  style={{paddingBottom: "80px"}}>
                    <Col>
                <hr></hr>
                <div style={{display: 'flex'}}>
                    <h2> IDEATION</h2>
                    <img
                      
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    
                    </div>
                    <h5>CRAZY 8</h5>
                    <div className="img-wrapper">
                    <img
                      src={crazy8}
                      alt="crazy 8"
                      // className="hover-zoom"
                    />
                    </div>
                    </Col>
                </Row>
                <Row style={{paddingBottom: '56px'}}>
                    <Col>
                    <hr></hr>
                    <div style={{display: 'flex'}}>
                    <h2>PROTOTYPE</h2>
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    <h5 style={{paddingBottom: '24px'}}>LOW FIDELITY:</h5>
                    <img
                      src={lowfidelity}
                      alt="low fidelity"
                      className="img-fluid"
                      style={{paddingBottom: '80px'}}
                    />
                    <h5>VISUAL IDENTITY:</h5>
                    <img
                      src={visualidentity}
                      alt="visual identity"
                      className="img-fluid"
                    />
                    </Col>
                </Row>
                <Row style={{paddingBottom: '64px'}}>
                <h5 style={{paddingBottom: '64px'}}>HIGH FIDELITY/ FINAL DESIGN:</h5>
                <Col style={{paddingBottom: '40px'}} sm={8}> 
                    <hr></hr>
                    <h2>Custom Menu</h2>
                    <p className="content">The menu would consist of everyday items that wouldn’t go bad in a day. The weekday special menus would have 3-4 specialties that would be available only on the said days.</p>
                    <p className="content">Thought Process: A workaround for the food that was not available in spite of being listed on the menu.</p>
                </Col>
                <Col sm={4} style={{textAlign: 'center'}}>
                <img
                      src={custommenu}
                      alt="Home Page - Custom Menu"
                      className="img-fluid"
                    //   style={{ maxHeight: "400px" }}
                    
                    />
                </Col>
                </Row>
                <Row style={{paddingBottom: '64px'}}>
                <Col style={{paddingBottom: '40px'}} sm={8}> 
                  <hr></hr>
                    <h2>Personalized Search</h2>
                    <p className="content">The filter and favourites feature was created to help you sort and quickly find your favourite snack.</p>
                </Col>
                <Col sm={4} style={{textAlign: 'right'}}>
                <img
                      src={psearch}
                      alt="Personalized Search"
                      className="img-fluid"
                    //   style={{ maxHeight: "400px" }}
                    
                    />
                </Col>
                </Row>
                <Row style={{paddingBottom: '64px'}}>
                <Col style={{paddingBottom: '40px'}} sm={8}> 
                    <hr></hr>
                    <h2>Efficient Ordering</h2>
                    <p className="content">It allows you to place your order an hour prior only if you complete the transaction online. You can even set up a pick up time based on your recess time according to which the canteen would make your order.</p>
                    <p className="content">Thought Process: To prevent long queues and easing the ordering process.</p>
                </Col>
                <Col sm={4} style={{textAlign: 'right'}}>
                <img
                      src={ordering}
                      alt="Efficient Ordering"
                      className="img-fluid"
                    //   style={{ maxHeight: "400px" }}
                    
                    />
                </Col>
                </Row>
                <Row style={{paddingBottom: '64px'}}>
                <Col style={{paddingBottom: '40px'}} sm={8}> 
                    <hr></hr>
                    <h2>Easy tracking</h2>
                    <p className="content">You can keep track of your order and collect once ready. The application also notifies you once your order is ready so that you don’t forget to collect it.</p>
                    <p className="content">Thought Process: No more forgetting to collect orders and eating cold meals.</p>
                </Col>
                <Col sm={4} style={{textAlign: 'right'}}>
                <img
                      src={tracking}
                      alt="Easy Tracking"
                      className="img-fluid"
                    //   style={{ maxHeight: "400px" }}
                    
                    />
                </Col>
                </Row>
                <Row style={{paddingBottom: '64px'}}>
                <Col style={{paddingBottom: '40px'}} sm={8}> 
                    <hr></hr>
                    <h2>The Staff's view (via separate staff login)</h2>
                    <p className="content">The staff would update the daily specials and availability of the food items as and when necessary.</p>
                    <p className="content">Once the order is placed online, depending on how long the preparation would take the staff would get notified to prepare and keep their next order ready before the delivery time.
                    </p>
                </Col>
                <Col sm={4} style={{textAlign: 'right'}}>
                <img
                      src={staff}
                      alt="Staff Screens"
                      className="img-fluid"
                    //   style={{ maxHeight: "400px" }}
                    
                    />
                </Col>
                </Row>
                <Row style={{paddingBottom: '40px'}}>
                  <Col>
                  <hr></hr>
                  <div style={{display: 'flex'}}>
                    <h2>USER FEEDBACK (STUDENTS) 
                      <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </h2>
                    
                    </div>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="content">01</p>
                      </Col>
                      <Col>
                      <p className="content">I like how the menu is different for everyday. It gives variety.</p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="content">02</p>
                      </Col>
                      <Col>
                      <p className="content">I like the order system where I can place my order for a specific time.</p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="content">03</p>
                      </Col>
                      <Col>
                      <p className="content">I wish the notes was a little more apparent.</p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="content">04</p>
                      </Col>
                      <Col>
                      <p className="content">I wonder if detailed food reviews could be added.</p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="content">05</p>
                      </Col>
                      <Col>
                      <p className="content">I like how i can track my order from placement to when it’s ready.</p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="content">06</p>
                      </Col>
                      <Col>
                      <p className="content">I think the canteen could announce on a speaker once your order was ready in case people missed their notification.</p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="content">07</p>
                      </Col>
                      <Col>
                      <p className="content">I would like it if without filter also I could know if I could get a particular item to be made Jain.</p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row style={{paddingBottom:"40px"}}>
                  <Col>
                    <hr></hr>
                    <div style={{display: 'flex'}}>
                    <h2>TAKEAWAYS</h2>
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    <p className="content">This project has focused on practising the design thinking process with a real-life problem. With a lot of research and brainstorming, we came to finalise this idea, which seemed perfect as we created it. But once we started retrospecting and counter-questioning our features, we did find some loopholes and knew we could improve on this project if we were to bring it to life.</p>
                    <p className="content">If we had enough time, we would have conducted surveys and iterated our entire procedure to find the optimal solution.</p>
                    <p className="content">Learned that problem-solving is not as simple as it may appear. When designing a product for a particular user, we should have considered the perspectives of all of the target audience.</p>
                  </Col>
                </Row>

                <Row style={{marginBottom: "100px", paddingTop:"40px", fontFamily: 'Changa', fontSize: '1.2em'}}>
                  <Link to={'/project/adwyzors'} style={{textDecoration: 'none'}}>
                    <div className="button-work" style={{border: "1px solid white",borderRadius:'5px', height: 'auto', width: '15%',color:'white', textAlign: 'center', verticalAlign: 'center', paddingTop: '10px', paddingBottom:'10px', position: 'absolute'}}>
                    Previous
                    </div>
                  </Link>
                  <Link to={'/project/healthpredictor'} style={{textDecoration: 'none'}}>
                    <div className="button-work" style={{border: "1px solid white",borderRadius:'5px', height: 'auto', width: '15%',color:'white', textAlign: 'center', verticalAlign: 'center', paddingTop: '10px', paddingBottom:'10px', position: 'absolute', right:'0px'}}>
                    Next
                    </div>
                  </Link>
                </Row> 
                </Container>
        </Container>
              </Col>
              </aside>
            </Row>
         
        <Footer />
      </Box>
    </section>
  );
}

export default ECanteen;
